const POWER_WORDS = {
  name: 'Power Words',
  slug: '/binder/power-words'
};

const SCHOOL_SUMMARY = {
  name: 'School Summary',
  slug: '/binder/school-summary'
};

const READING_SUMMARY = {
  name: 'Reading Summary',
  slug: '/binder/students'
};

const ACTIVITY_FEED = {
  name: 'Activity Feed',
  slug: '/binder/activity-feed'
};

const YOUR_PROGRESS = {
  name: 'Your Progress',
  slug: '/student-binder/assignments'
};

const YOUR_WORD_WALL = {
  name: 'Word Wall',
  slug: '/student-binder/word-wall'
};

export const DISTRICT_CONSTANTS = {
  name: 'District',
  slug: '/admin-binder'
};

export const PRINCIPAL_CONSTANTS = {
  name: 'School Performance',
  slug: '/admin-binder'
};

export const DISTRICT_ADMINS_CONSTANTS = {
  name: 'District Insights',
  slug: '/reporting/admin'
};

export const SCHOOL_ADMINS_CONSTANTS = {
  name: 'School Insights',
  slug: '/reporting/admin'
};

export const ELA_CONSTANTS = {
  name: 'English Language Arts',
  slug: '/content/browse/ela-browse-page/'
};

export const SCIENCE_CONSTANTS = {
  name: 'Science',
  slug: '/content/browse/browse-science/'
};

export const SOCIAL_STUDIES_CONSTANTS = {
  name: 'Social Studies',
  slug: '/content/browse/browse-social-studies/'
};

export const EN_ESPANOL_CONSTANTS = {
  lang: 'es',
  name: 'En Español',
  slug: '/content/browse/spanish-browse-page/'
};

export const NEWS_CONSTANTS = {
  name: 'News',
  slug: '/content/browse/news-browse-page/'
};

export const TEACHER_BINDER_CONSTANTS = {
  ACTIVITY_FEED,
  POWER_WORDS,
  READING_SUMMARY,
  SCHOOL_SUMMARY,
};

export const STUDENT_BINDER_CONSTANTS = {
  YOUR_PROGRESS,
  YOUR_WORD_WALL
};
